"use client";

import { c as _c } from "react/compiler-runtime";
import { Plus, X } from "lucide-react";
import { ModelSelector } from "@/components/model-selector";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Switch } from "@/components/ui/switch";
import type { ApiModel, ApiProvider } from "@/lib/fetch-models";
interface VideoHeaderProps {
  models: ApiModel[];
  providers: ApiProvider[];
  selectedModels: string[];
  onModelChange: (index: number, model: string) => void;
  onAddModel: () => void;
  onRemoveModel: (index: number) => void;
  comparisonMode: boolean;
  onComparisonModeChange: (enabled: boolean) => void;
  isModelOptionDisabled?: (value: string) => boolean;
  getModelOptionDisabledReason?: (value: string) => string | undefined;
  hideCompare?: boolean;
}
export function VideoHeader(t0) {
  const $ = _c(18);
  const {
    models,
    providers,
    selectedModels,
    onModelChange,
    onAddModel,
    onRemoveModel,
    comparisonMode,
    onComparisonModeChange,
    isModelOptionDisabled,
    getModelOptionDisabledReason,
    hideCompare: t1
  } = t0;
  const hideCompare = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SidebarTrigger />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== comparisonMode || $[2] !== getModelOptionDisabledReason || $[3] !== isModelOptionDisabled || $[4] !== models || $[5] !== onAddModel || $[6] !== onModelChange || $[7] !== onRemoveModel || $[8] !== providers || $[9] !== selectedModels) {
    t3 = <div className="flex min-w-0 flex-1 items-center gap-3">{t2}{comparisonMode ? <div className="flex min-w-0 flex-1 items-center gap-2 overflow-x-auto">{selectedModels.map((model, index) => <div key={index} className="flex items-center gap-1 shrink-0"><div className="w-[200px] min-w-[200px]"><ModelSelector models={models} providers={providers} value={model} onValueChange={v => onModelChange(index, v)} placeholder="Select model..." mode="video" isOptionDisabled={isModelOptionDisabled} getOptionDisabledReason={getModelOptionDisabledReason} /></div>{selectedModels.length > 1 && <Button variant="ghost" size="icon" className="h-7 w-7 shrink-0" onClick={() => onRemoveModel(index)}><X className="h-3.5 w-3.5" /></Button>}</div>)}{selectedModels.length < 3 && <Button variant="outline" size="sm" className="shrink-0" onClick={onAddModel}><Plus className="h-3.5 w-3.5 mr-1" />Add</Button>}</div> : <div className="flex w-full min-w-0 max-w-[360px] items-center gap-2 sm:max-w-[420px]"><ModelSelector models={models} providers={providers} value={selectedModels[0] ?? ""} onValueChange={v_0 => onModelChange(0, v_0)} placeholder="Select a video model..." mode="video" isOptionDisabled={isModelOptionDisabled} getOptionDisabledReason={getModelOptionDisabledReason} /></div>}</div>;
    $[1] = comparisonMode;
    $[2] = getModelOptionDisabledReason;
    $[3] = isModelOptionDisabled;
    $[4] = models;
    $[5] = onAddModel;
    $[6] = onModelChange;
    $[7] = onRemoveModel;
    $[8] = providers;
    $[9] = selectedModels;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== comparisonMode || $[12] !== hideCompare || $[13] !== onComparisonModeChange) {
    t4 = (!hideCompare || comparisonMode) && <div className="ml-3 flex items-center gap-3"><div className="hidden items-center gap-2 md:flex">{hideCompare ? <span className="text-muted-foreground text-xs">Comparison Mode</span> : <><Label htmlFor="comparison-mode-vid" className="text-muted-foreground text-xs">Comparison Mode</Label><Switch id="comparison-mode-vid" checked={comparisonMode} onCheckedChange={onComparisonModeChange} /></>}</div></div>;
    $[11] = comparisonMode;
    $[12] = hideCompare;
    $[13] = onComparisonModeChange;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <header className="bg-background flex items-center border-b p-4">{t3}{t4}</header>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}